export default "__VITE_ASSET__BKTQbsiA__"